if (!window.awHomeLoaded) {
  window.awHomeLoaded = true;

  const AW_REVEAL_STEP = 70;
  const AW_REVEAL_MAX_STEPS = 5;

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileQuery = window.matchMedia('(max-width: 989px)');

  const SLIDERS = [
    {
      root: '[data-aw-values-slider]',
      track: '[data-aw-values-track]',
      prev: '[data-aw-values-prev]',
      next: '[data-aw-values-next]',
      autoplayKey: 'awValuesAutoplay',
      intervalKey: 'awValuesInterval',
      desktopVar: '--aw-items-desktop',
      mobileVar: '--aw-items-mobile',
    },
    {
      root: '[data-aw-reviews-slider]',
      track: '[data-aw-reviews-track]',
      prev: '[data-aw-reviews-prev]',
      next: '[data-aw-reviews-next]',
      autoplayKey: 'awReviewsAutoplay',
      intervalKey: 'awReviewsInterval',
      desktopVar: '--aw-review-items-desktop',
      mobileVar: '--aw-review-items-mobile',
    },
  ];

  function setupReveal(root) {
    const items = Array.from(root.querySelectorAll('[data-aw-reveal]:not(.aw-reveal-ready)'));
    if (!items.length) return null;

    items.forEach((item) => item.classList.add('aw-reveal-ready'));

    if (motionQuery.matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('aw-is-visible'));
      return null;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('aw-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    items.forEach((item, index) => {
      const box = item.getBoundingClientRect();
      const alreadyOnScreen = box.top < window.innerHeight && box.bottom > 0;

      if (alreadyOnScreen) {
        item.classList.add('aw-is-visible');
        return;
      }

      item.classList.add('aw-reveal-armed');
      item.style.transitionDelay = Math.min(index % 6, AW_REVEAL_MAX_STEPS) * AW_REVEAL_STEP + 'ms';
      observer.observe(item);
    });

    return observer;
  }

  function setupSlider(slider, config) {
    const track = slider.querySelector(config.track);
    if (!track) return null;

    const cards = Array.from(track.children);
    const prev = slider.querySelector(config.prev);
    const next = slider.querySelector(config.next);
    const autoplay = slider.dataset[config.autoplayKey] === 'true';
    const interval = Number(slider.dataset[config.intervalKey]) || 5000;

    let index = 0;
    let timer = null;
    let frame = null;

    const behavior = () => (motionQuery.matches ? 'auto' : 'smooth');

    const visibleItems = () => {
      const name = mobileQuery.matches ? config.mobileVar : config.desktopVar;
      const value = getComputedStyle(track).getPropertyValue(name);
      return Math.max(1, Number(value) || 1);
    };

    const show = (nextIndex) => {
      const maxIndex = Math.max(0, cards.length - visibleItems());
      index = nextIndex > maxIndex ? 0 : nextIndex < 0 ? maxIndex : nextIndex;

      const card = cards[index];
      if (!card) return;

      const left = card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollTo({ left, behavior: behavior() });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (!autoplay || motionQuery.matches || cards.length <= visibleItems()) return;
      timer = window.setInterval(() => show(index + 1), interval);
    };

    const onResize = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        show(index);
      });
    };

    if (prev) {
      prev.addEventListener('click', () => {
        show(index - 1);
        start();
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        show(index + 1);
        start();
      });
    }

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    window.addEventListener('resize', onResize, { passive: true });

    track.scrollLeft = 0;
    start();

    return {
      destroy() {
        stop();
        window.removeEventListener('resize', onResize);
        if (frame) window.cancelAnimationFrame(frame);
      },
    };
  }

  function initAwHome(root) {
    const scope = root || document;

    const observer = setupReveal(scope);
    const instances = [];

    SLIDERS.forEach((config) => {
      scope.querySelectorAll(config.root).forEach((slider) => {
        if (slider.awHomeSlider) slider.awHomeSlider.destroy();
        const instance = setupSlider(slider, config);
        if (!instance) return;
        slider.awHomeSlider = instance;
        instances.push(instance);
      });
    });

    if (root && root.nodeType === 1) {
      if (root.awHome) root.awHome.destroy();
      root.awHome = {
        destroy() {
          if (observer) observer.disconnect();
          instances.forEach((instance) => instance.destroy());
        },
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAwHome());
  } else {
    initAwHome();
  }

  document.addEventListener('shopify:section:load', (event) => initAwHome(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    const target = event.target;
    if (target.awHome) target.awHome.destroy();
    target.querySelectorAll('[data-aw-values-slider], [data-aw-reviews-slider]').forEach((slider) => {
      if (slider.awHomeSlider) slider.awHomeSlider.destroy();
    });
  });
}